import './SellerVATIdsOverview.scss';
import { VATId } from '../../core/types';
import { ClientTaxDetailsStatusEnum, SellerRoutesEnum } from '../../core/enums';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Flag from '../../components/CountryLabel/Flag';
import { Link } from 'react-router-dom';

const VAT_LABELS: {
  [key: string]: string;
} = {
  registered: 'Active',
  in_progress: 'In progress',
  deregistered: 'Inactive',
};

interface Props {
  inProgressData: VATId[];
  registered: VATId[];
}

export default function SellerVATIdsOverview({
  inProgressData,
  registered,
}: Props) {
  const { t } = useTranslation();

  const deregistered = inProgressData.filter(
    (v) => v.status === ClientTaxDetailsStatusEnum.DEREGISTERED
  );

  const inProgress = inProgressData.filter(
    (v) => v.status !== ClientTaxDetailsStatusEnum.NOT_NEEDED
  );

  const isSingleItem =
    [!!registered.length, !!inProgress.length, !!deregistered.length].filter(
      (v) => !!v
    ).length === 1;

  const colClassName = classNames('col SellerVATIdsOverview__col', {
    'd-flex flex-column align-items-center': isSingleItem,
  });

  const vatIds = [
    {
      key: 'registered',
      items: registered,
    },
    {
      key: 'in_progress',
      items: inProgress,
    },
    {
      key: 'deregistered',
      items: deregistered,
    },
  ];

  if (!registered.length && !inProgress.length && !deregistered.length)
    return null;

  return (
    <div className='Paper mb-3 pt-2 pb-3 px-3'>
      <div className='fw-800 mb-2' data-testid='seller-vatids-overview-title'>
        {t('VAT IDs')}
      </div>
      <div className='row mx-n3'>
        {vatIds.map(
          (v) =>
            !!v.items.length && (
              <Link
                className={colClassName}
                to={SellerRoutesEnum.VAT}
                key={v.key}
              >
                <div
                  className='Text--gray'
                  data-testid={`seller-vatids-overview-${v.key}-label`}
                >
                  {t(VAT_LABELS[v.key])}
                </div>
                <div
                  className='fw-light SellerVATIdsOverview__title mb-2'
                  data-testid={`seller-vatids-overview-${v.key}-value`}
                >
                  {v.items.length}
                </div>
                <div className='row row-cols-auto gx-0 SellerVATIdsOverview__flags'>
                  {v.items.map((item) => (
                    <div
                      className='col SellerVATIdsOverview__flagCol'
                      key={item.Country.short_name}
                      data-testid={`seller-vatids-overview-${v.key}-${item.Country.short_name}-flag`}
                    >
                      <Flag country={item.Country.short_name} />
                    </div>
                  ))}
                </div>
              </Link>
            )
        )}
      </div>
    </div>
  );
}
